import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const SITE_NAME = 'Next Step Denmark';

/**
 * Sets <title> and <meta name="description"> for the current page.
 * Re-runs when language changes so the tab title updates with the language switcher.
 *
 * @param {string} titleKey - dot-notation translation key, e.g. "about.title"
 * @param {string} descriptionKey - dot-notation translation key for description (optional)
 */
export const usePageMeta = (titleKey, descriptionKey) => {
  const { t, language } = useLanguage();

  useEffect(() => {
    const pageTitle = titleKey ? t(titleKey) : '';
    document.title = pageTitle ? `${pageTitle} — ${SITE_NAME}` : SITE_NAME;

    if (descriptionKey) {
      const description = t(descriptionKey);
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [titleKey, descriptionKey, language, t]);
};
